import React from "react";
import { ScrollView, useWindowDimensions, View } from "react-native";
import VipCard from "./VipCard";

import {
  SmallVipOne,
  SmallVipSix,
  SmallVipTwelve,
  VipOneImage,
  VipSixImage,
  VipTwelveImage,
} from "../../../../assets";
import { useDevice } from "../../../../utils/hooks/useDevice";
import { Package } from "../../../../store/types";
import VipCardDesktop from "./VipCardDesktop";

interface VipScreenProps {
  vipPackages: Package[];
  onPayment: (pkg: Package) => void;
}

const VipScreen: React.FC<VipScreenProps> = ({ vipPackages, onPayment }) => {
  const { isPortrait } = useDevice();
  const { width } = useWindowDimensions();
  const shouldUseMobileLayout = isPortrait || width < 1000;
  if (shouldUseMobileLayout) {
    return (
      <>
        <View
          style={{
            width: "100%",
            maxWidth: 900,
            alignSelf: "center",
            maxHeight: 420,
            flex: 1,
            minHeight: 0,
          }}
        >
          {/* <ScrollView
            style={{ flex: 1 }}
            contentContainerStyle={{ padding: 10 }}
            showsVerticalScrollIndicator={true}
            nestedScrollEnabled={true}
            keyboardShouldPersistTaps="handled"
          > */}
          {vipPackages.map((item, index) => {
            return (
              <VipCard
                key={item.id}
                vipIcon={VipOneImage}
                borderColor="#C0C0C0"
                textColor="#FFD700"
                vipLabel={SmallVipOne}
                name={item.name}
                price={Number(item.price) || 0}
                pkg={item}
                onPayment={onPayment}
              />
            );
          })}
          {/* </ScrollView> */}
        </View>
      </>
    );
  }

  return (
    <>
      <View
        style={{
          width: "100%",

          flex: 1,
          minHeight: 0,
          justifyContent: "center",
        }}
      >
        {/* <ScrollView
          horizontal
          style={{ flex: 1 }}
          contentContainerStyle={{ padding: 10, justifyContent: "center" }}
          showsVerticalScrollIndicator={true}
          nestedScrollEnabled={true}
          keyboardShouldPersistTaps="handled"
        > */}
        <View
          style={{
            padding: 10,
            justifyContent: "center",
            flex: 1,
            flexDirection: "row",
          }}
        >
          {vipPackages.map((item, index) => {
            return (
              <VipCardDesktop
                key={item.id}
                vipIcon={VipOneImage}
                borderColor="#C0C0C0"
                textColor="#ccc"
                vipLabel={SmallVipOne}
                name={item.name}
                price={Number(item.price) || 0}
                pkg={item}
                onPayment={onPayment}
              />
            );
          })}
        </View>
        {/* </ScrollView> */}
      </View>
    </>
  );
};

export default VipScreen;
